import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from 'lib/supabase';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState(null);
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    const checkUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (user) {
        setIsAuth(true);
        const { data: profil } = await supabase
          .from('profili')
          .select('ruolo')
          .eq('id', user.id)
          .single();
        
        setUserRole(profil?.ruolo);
      }
      setLoading(false);
    };
    checkUser();
  }, []);

  if (loading) return <div className="flex h-screen items-center justify-center">Loading...</div>;

  // Ako nije logovan, šalji na login
  if (!isAuth) return <Navigate to="/" replace />;

  // Ako uloga nije dozvoljena, šalji na 404 (ili error stranicu)
  if (allowedRoles && !allowedRoles.includes(userRole)) {
    return <Navigate to="/404" replace />;
  }

  return children;
};

export default ProtectedRoute;